var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.suggestions && _vm.suggestions.length > 0)?_c('div',{staticClass:"suggestions"},[_vm._v("Essayez avec : "),_vm._l((_vm.suggestions),function(suggestion,index){return _c('span',{key:index},[_c('router-link',{attrs:{"to":{
      path: '/' + _vm.$searchResultManager.conceptsCatalogSlug + '/',
      query: {
        ..._vm.$route.query,
        search: suggestion
      }
    }}},[_vm._v(_vm._s(suggestion))])],1)})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }